import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { setCookie } from "../../utilities/client/cookie";

import PropTypes from "prop-types";
import ButtonNewsletter from "../ButtonNewsletter";
import {
  StyledNewsletter,
  StyledWrapper,
  StyledInputWrapper,
  StyledInput,
  StyledNewsletterHeading,
  StyledErrorMsg,
  StyledResponse,
  HiddenLabel,
} from "./styles";

export const Newsletter = ({
  context = null,
  clientContext = null,
  submitStyles = null,
  headerStyles = null,
  containerStyles = null,
  redirectTo = null,
  // headerText = null,
  // dataLabel = null,
  submitText = null,
  id = "Newsletter",
  name = "Newsletter",
  className = "hydrate hydrateNewsletter",
}) => {
  // Extract settings/
  let { isMobile } = clientContext;
  let { settings } = context.data;
  const {
    tfa_35,
    tfa_41,
    tfa_39,
    tfa_dbFormId,
    tfa_dbResponseId,
    tfa_dbControl,
    tfa_dbWorkflowSessionUuid,
    tfa_noOverWriteFields,
    tfa_dbVersionId,
    tfa_switchedoff,
  } = settings.formHiddenFields.aframeList;

  const {
    response,
    firstName,
    lastName,
    email,
    firstNameError,
    lastNameError,
    emailError,
    // submitText,
    dataLabel,
    headerText,
  } = settings.footer.form;

  let tfa_565 = "";
  let tfa_566 = "";
  let tfa_567 = "";

  if (typeof window !== "undefined" && window.location.search !== undefined) {
    let params = new URLSearchParams(window.location.search);
    tfa_565 = params.get("utm_source");
    tfa_566 = params.get("utm_medium");
    tfa_567 = params.get("utm_campaign");
  }

  const { register, handleSubmit, errors, formState } = useForm({
    mode: "onChange",
  });

  const [showThankYou, setShowThankYou] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const onSubmit = (data) => {
    setDisableSubmit(true);
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    fetch("https://ammp.tfaforms.net/api_v2/workflow/processor", {
      method: "POST",
      mode: "no-cors",
      body: formData,
    })
      .then((res) => {
        if (res) {
          setShowThankYou(true);
          setCookie("AframeNewsletter", "true");
          // redirect is needed when in the create list flow
          // it can be used with the Newsletter component every time a signup occurs.
          // Passing the redirectTo is needed when a new navigation is needed
          // eslint-disable-next-line no-unused-expressions
          redirectTo && redirectTo();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  if (showThankYou) {
    return (
      <StyledNewsletter>
        <StyledNewsletterHeading customstyles={headerStyles} noMargin>
          {headerText}
        </StyledNewsletterHeading>
        <StyledResponse>{response}</StyledResponse>
      </StyledNewsletter>
    );
  }

  return (
    <StyledNewsletter
      customstyles={containerStyles}
      id={id}
      name={name}
      className={className}
    >
      <StyledNewsletterHeading customstyles={headerStyles}>
        {headerText}
      </StyledNewsletterHeading>

      <form onSubmit={handleSubmit(onSubmit)}>
        <StyledWrapper isMobile={isMobile}>
          <StyledInputWrapper isMobile={isMobile}>
            <HiddenLabel htmlFor="tfa_1">{firstName}</HiddenLabel>
            <StyledInput
              type="text"
              id="tfa_1"
              name="tfa_1"
              ref={register({ required: true })}
              title={firstName}
              placeholder={firstName}
            />
            <StyledErrorMsg>{errors.tfa_1 && firstNameError}</StyledErrorMsg>
          </StyledInputWrapper>
          <StyledInputWrapper isMobile={isMobile}>
            <HiddenLabel htmlFor="tfa_2">{lastName}</HiddenLabel>
            <StyledInput
              type="text"
              id="tfa_2"
              name="tfa_2"
              ref={register({ required: true })}
              title={lastName}
              placeholder={lastName}
            />
            <StyledErrorMsg>{errors.tfa_2 && lastNameError}</StyledErrorMsg>
          </StyledInputWrapper>
          <StyledInputWrapper fullWidth isMobile={isMobile}>
            <HiddenLabel htmlFor="tfa_3">{email}</HiddenLabel>
            <StyledInput
              type="email"
              id="tfa_3"
              name="tfa_3"
              ref={register({
                required: true,
                pattern: {
                  value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: "Please enter a valid email address",
                },
              })}
              title={email}
              placeholder={email}
            />
            <StyledErrorMsg>{errors.tfa_3 && emailError}</StyledErrorMsg>
          </StyledInputWrapper>
        </StyledWrapper>
        <input ref={register({ required: false })} type="hidden" id="tfa_35" name="tfa_35" value={`${tfa_35} 1`} />
        <input ref={register({ required: false })} type="hidden" id="tfa_41" name="tfa_41" value={tfa_41} />
        <input ref={register({ required: false })} type="hidden" id="tfa_39" name="tfa_39" value={tfa_39} />

        <input ref={register({ required: false })} type="hidden" id="tfa_565" name="tfa_565" value={tfa_565} />
        <input ref={register({ required: false })} type="hidden" id="tfa_566" name="tfa_566" value={tfa_566} />
        <input ref={register({ required: false })} type="hidden" id="tfa_567" name="tfa_567" value={tfa_567} />

        <input ref={register({ required: false })} type="hidden" name="tfa_dbFormId" id="tfa_dbFormId" value={tfa_dbFormId} />
        <input ref={register({ required: false })} type="hidden" name="tfa_dbResponseId" id="tfa_dbResponseId" value={tfa_dbResponseId} />
        <input ref={register({ required: false })} type="hidden" name="tfa_dbControl" id="tfa_dbControl" value={tfa_dbControl} />
        <input ref={register({ required: false })} type="hidden" name="tfa_dbWorkflowSessionUuid" id="tfa_dbWorkflowSessionUuid" value={tfa_dbWorkflowSessionUuid} />
        <input ref={register({ required: false })} type="hidden" name="tfa_noOverWriteFields" id="tfa_noOverWriteFields" value={tfa_noOverWriteFields} />
        <input ref={register({ required: false })} type="hidden" name="tfa_dbVersionId" id="tfa_dbVersionId" value={tfa_dbVersionId} />
        <input ref={register({ required: false })} type="hidden" name="tfa_switchedoff" id="tfa_switchedoff" value={tfa_switchedoff} />
        <ButtonNewsletter
          text={submitText}
          styles={submitStyles}
          isDisabled={!formState.isValid || disableSubmit}
          type="submit"
          data-label={dataLabel}
        />
      </form>
    </StyledNewsletter>
  );
};

export default Newsletter;

Newsletter.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object.isRequired,
  /**
   Server side variables
  */
  context: PropTypes.object.isRequired,
  /**
   Submit button text
  */
  submitText: PropTypes.string.isRequired,
  /**
   Header text
  */
  headerText: PropTypes.string,
  /**
   Optional submit button styles
  */
  submitStyles: PropTypes.object,
  /**
   Optional header styles
  */
  headerStyles: PropTypes.object,
  /**
   Optional data label
  */
  dataLabel: PropTypes.string,
  /**
   Optional container styles
  */
  containerStyles: PropTypes.object,
  /**
   Optional redirect to function
  */
  redirectTo: PropTypes.func,
  /**
   isMobile boolean
  */
  isMobile: PropTypes.bool,
};
